import { GmaStockCategoria } from './gma-stock-categoria';
import { GmaStockLeaf } from './gma-stock-leaf';


export class GmaDynamicFlatNode {
    constructor(public item:GmaStockCategoria | GmaStockLeaf, public level = 1, public expandable = false, public isLoading = false){

    }
}
